// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
import ___CSS_LOADER_URL_IMPORT_0___ from "../../../../../assets/images/tabs_bcg.svg";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1XmXl19A9tj_X4SPv3bQl8{height:100%;display:flex;flex-direction:column;position:relative}.doClSDrioZ1mF0ZZD6k-f{padding:.35714rem;height:100%}._31NOKztb_7e8Ewaad2ZrMS{background:#fff;padding-top:.5rem}._1LnnZtCFFvNCBIb4QDZ41h{position:absolute;z-index:3;width:100%;height:100%;display:flex;flex-direction:column;visibility:hidden;opacity:0;transition:all 0.5s;background:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + "),#fff}._1l8uUP8RQ-mUjVRa4CR0Al{visibility:visible;opacity:100}._3bwTxfhbVT-2aURNpQ52yt{margin:1.42857rem auto;text-align:center;display:inline-flex;justify-content:center;width:100%}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cheer": "_1XmXl19A9tj_X4SPv3bQl8",
	"cheer__content": "doClSDrioZ1mF0ZZD6k-f",
	"cheer__bottomBar": "_31NOKztb_7e8Ewaad2ZrMS",
	"cheer__successView": "_1LnnZtCFFvNCBIb4QDZ41h",
	"cheer__successView_visible": "_1l8uUP8RQ-mUjVRa4CR0Al",
	"cheer__warningInfo": "_3bwTxfhbVT-2aURNpQ52yt"
};
export default ___CSS_LOADER_EXPORT___;
